<template>
  <v-container fluid class="fill-height">
    <v-row justify="center" align="center" class="fill-height">
      <v-col cols="12" md="6" class="text-center">
        <v-icon size="64" color="grey">mdi-cloud-off-outline</v-icon>
        <h1 class="text-h4 mt-4">Service temporairement indisponible</h1>
        <p class="mt-2 grey--text">
          Le serveur ne répond pas actuellement. Merci de réessayer dans quelques instants.
        </p>
        <v-btn color="primary" class="mt-4" :loading="retrying" @click="retry">
          <v-icon class="mr-2">mdi-refresh</v-icon>
          Réessayer
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { reportError } from '@/services/errorReportingApi'

export default {
  name: 'ServiceUnavailableView',
  data: () => ({
    retrying: false,
  }),
  created() {
    reportError({
      context: 'app:service-unavailable',
      url: this.$route.fullPath,
      message: 'Service unavailable page shown',
    })
  },
  methods: {
    async retry() {
      this.retrying = true
      await this.$store.dispatch('health/checkHealth')
      this.retrying = false
    },
  },
}
</script>
